import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";
import ThisDayContainer from "~/Containers/ThisDayContainer";
import Tile from "~/Components/Tile";
import { formatThisDayLabel, parseThisDayParam } from "~/api/getThisDayPosts";

const Kba = window.dreamchimney && window.dreamchimney.kba;

const ThisDayPage = () => {
  const { search } = useLocation();
  const dateParam = new URLSearchParams(search).get("date");
  const parsed = parseThisDayParam(dateParam);
  const now = new Date();
  const month = parsed ? parsed.month : now.getMonth() + 1;
  const day = parsed ? parsed.day : now.getDate();
  const dateLabel = formatThisDayLabel(month, day);
  const invalidDate = Boolean(dateParam) && !parsed;
  const canonical = parsed
    ? `https://www.dreamchimney.com/oftheday/thisday?date=${String(month).padStart(2, "0")}${String(day).padStart(2, "0")}`
    : "https://www.dreamchimney.com/oftheday/thisday";

  return (
    <div className="home-page-component">
      <Helmet>
        <title>This Day in History ({dateLabel}) | ____ of the Day | Dream Chimney</title>
        <link rel="canonical" href={canonical} />
      </Helmet>
      <div className="pageTitle">This day in history ({dateLabel})</div>
      <div className="home-component">
        {invalidDate ? (
          <p style={{ color: "#fff" }}>
            That date doesn’t look right. Use <code>?date=MMDD</code> — for example{" "}
            <code>?date=0819</code> for August 19.
          </p>
        ) : (
          <ThisDayContainer
            key={parsed ? `${month}${day}` : "today"}
            dateParam={parsed ? `${String(month).padStart(2, "0")}${String(day).padStart(2, "0")}` : null}
            render={({ posts, loading, failure }) => {
              if (loading) {
                return (
                  <div className="container-loading">
                    <Spinner animation="border" size="sm" /> Loading...
                  </div>
                );
              }
              if (failure) {
                return <p style={{ color: "#fff" }}>Couldn’t load posts for this date. Try again soon.</p>;
              }
              if (!posts.length) {
                return (
                  <p style={{ color: "#fff" }}>
                    Nothing was posted on {dateLabel} in past years.
                    {!parsed && " Check back tomorrow."}
                  </p>
                );
              }
              return (
                <Row noGutters className="minimalGutter">
                  {posts.map((item) => (
                    <Col xl={4} lg={6} xs={12} key={item.id}>
                      <Tile archive showDate otd={item} />
                    </Col>
                  ))}
                </Row>
              );
            }}
          />
        )}
        {Kba && (
          <div style={{ padding: "40px 0" }}>
            <Kba />
          </div>
        )}
      </div>
    </div>
  );
};

export default ThisDayPage;
